import getConstants, { defaultPath } from '@/shared/constants';

import { routes } from './app/routes';

const { routerBasePath } = getConstants();

const basePath =
  routerBasePath[routerBasePath.length - 1] === '/'
    ? routerBasePath.slice(0, -1)
    : routerBasePath;

const defaultPathWithBase = `${basePath}${defaultPath}`;

export default [
  ...routes.map(i => ({ ...i, path: `${basePath}${i.path}` })),
  {
    path: '/:pathMatch(.*)*',
    redirect: defaultPathWithBase,
  },
];
